<template>
  <div class="poster">
    <div class="content" id="poster-1">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/158345c067ba78f0f2b203c1b17ba65b.png"
        alt=""
      />
      <div class="day">{{ data.headerDatum.day }}天</div>
      <div class="time">{{ data.headerDatum.time | timeLineToDot }}</div>
      <div class="nickname"
        >{{ data.headerDatum.alias }} {{ data.user.truename }}同学</div
      >
      <div class="body-info">
        <div class="body-item">
          <div class="b-item-name">体重</div>
          <div class="b-item-num">{{
            data.infoDatum.weight | filterBodyInfo
          }}</div>
          <div class="b-item-unit">KG</div>
        </div>
        <div class="body-item">
          <div class="b-item-name">腰围</div>
          <div class="b-item-num">{{
            data.infoDatum.waist | filterBodyInfo
          }}</div>
          <div class="b-item-unit">CM</div>
        </div>
        <div class="body-item" v-if="data.infoDatum.thigh">
          <div class="b-item-name">大腿围</div>
          <div class="b-item-num">{{
            data.infoDatum.thigh | filterBodyInfo
          }}</div>
          <div class="b-item-unit">CM</div>
        </div>
      </div>
      <div class="diet-info">
        <div class="diet-item"
          ><span class="diet-bold">{{ data.infoDatum.meal_day }}</span
          ><span>/{{ data.headerDatum.day }}天</span></div
        >
        <div class="diet-item"
          ><span class="diet-bold">{{ data.infoDatum.meal_num }}</span
          ><span>/{{ data.headerDatum.day * 3 }}餐</span>
        </div>
        <div class="diet-item"
          ><span class="diet-bold">{{ data.infoDatum.star5_num }}</span
          ><span>餐满分</span></div
        >
      </div>
      <div class="p-bottom">
        <img
          class="qrcode"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/defef34ca03675b0a9844be2052e832e.png"
          alt=""
        />
        <div class="b-left">
          <div class="b-center">
            <div>和我一起打卡变瘦</div>
            <div>学习更多减脂冷知识</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  filters: {
    timeLineToDot(val) {
      val = val.replace(/--/g, '#')
      val = val.replace(/-/g, '.')
      val = val.replace(/#/g, '-')
      return val
    },
    filterBodyInfo(value) {
      if (value > 0) {
        return '+' + value
      } else if (value == 0) {
        return '-0'
      } else {
        return value
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.poster {
  position: fixed;
  left: 200%;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: rgba(0, 0, 0, 0.6);

  .content {
    position: relative;
    width: 100%;
    height: 499px;

    .image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      object-fit: contain;
    }

    .day {
      position: absolute;
      left: 285px;
      top: 117px;
      font-size: 12px;
      font-style: italic;
      font-family: Source-KeynoteartHans-Regular, Source-KeynoteartHans;
      color: #ffeee5;
      line-height: 14px;
      padding: 2px 4px;
      font-weight: 600;
      background: linear-gradient(157deg, #654369 0%, #352038 100%);
      border-radius: 5px 5px 5px 0px;
    }

    .time {
      position: absolute;
      font-size: 15px;
      font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
      color: #ffffff;
      line-height: 21px;
      top: 164px;
      left: 50%;
      transform: translate(-50%, 0%);
    }

    .nickname {
      max-width: 80.5vw;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: absolute;
      left: 50%;
      top: 202px;
      transform: translate(-50%, 0%);
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      padding: 2px;
      border-bottom: 1px solid rgba(50, 50, 73, 0.3);
      line-height: 25px;
    }

    .body-info {
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: absolute;
      padding: 0px 0px;
      box-sizing: border-box;
      top: 290px;
      left: 50%;
      transform: translate(-50%, 0%);
      width: 91.2vw;

      .body-item {
        display: flex;
        align-items: flex-end;
        justify-content: center;

        .b-item-name {
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 14px;
          margin-right: 4px;
        }

        .b-item-num {
          height: 27px;
          //min-width: 83px;
          font-size: 22px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          line-height: 34px;
          color: rgba(0, 0, 0, 0.8);
        }

        .b-item-unit {
          font-size: 10px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 12px;
          margin-left: 4px;
        }
      }
    }

    .diet-info {
      width: 82.13vw;
      height: 61px;
      position: absolute;
      left: 50%;
      top: 352px;
      transform: translate(-50%, 0%);
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.8);
      margin-bottom: 12px;

      .diet-bold {
        font-family: DIN-Medium;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.8);
        font-weight: 600;
      }
    }

    .p-bottom {
      position: absolute;
      width: 308px;
      left: 50%;
      bottom: 20px;
      transform: translate(-50%, 0%);
      display: flex;
      align-items: center;

      .qrcode {
        width: 56px;
        height: 56px;
        object-fit: contain;
        margin-right: 10px;
      }

      .b-left {
        display: flex;
        align-items: flex-end;

        .b-center {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 18px;
        }

        .logo {
          width: 66px;
        }
      }
    }
  }
}
</style>
